import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react';

type HoverState = {
  onHoverChange: (hovered: boolean) => void;
  hovered: boolean;
};

const HoverContext = createContext<HoverState | null>(null);

export const HoverProvider = ({ children }: PropsWithChildren) => {
  const [hovered, setHovered] = useState(false);

  const onHoverChange = useCallback((newValue: boolean) => {
    setHovered(newValue);
  }, []);

  return (
    <HoverContext.Provider
      value={{
        onHoverChange,
        hovered,
      }}
    >
      {children}
    </HoverContext.Provider>
  );
};

export const useIsChartHovered = () => {
  return useContext(HoverContext) as HoverState;
};
